// extracted by mini-css-extract-plugin
module.exports = {"styyu2x":"styyu2x","m1lfvlfz":"m1lfvlfz"};